import React from 'react';
import AutoSizeTitle from '../../components/autoSizeTitle/AutoSizeTitle';
import IndividualInformHeader from '../../components/individualInformHeader/individualInformHeader';
import { formatVisibleNumber } from '../../components/selfcare360/selfcare360Scales';
import {
    formatCompactPercent,
    getIpraInterventionPlan,
} from './selfcare360InterventionPlan';
import './planSelfcare360.css';

const PageInterventionPlanDimensionSelfcare360 = ({ selectedEvaluation, individualResult, orgLogo, pageNumber, planRow }) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    const plan = getIpraInterventionPlan(planRow?.code, planRow?.tier?.key);
    if (!planRow || !plan) return null;

    const firstName = individualResult?.first_name || 'Supervisor';

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation?.evl_title} />

                <div className="internal-page-info internal-page-info-individual">
                    <IndividualInformHeader individualResult={individualResult} orgLogo={orgLogo} />

                    <div className="selfcare360-plan-detail-header">
                        <div className="selfcare360-plan-detail-title-wrap">
                            <div className="selfcare360-plan-detail-kicker">Plan de intervención prioritaria</div>
                            <h2 className="selfcare360-plan-detail-title">{planRow.code} {planRow.planTitle}</h2>
                        </div>

                        <span
                            className="selfcare360-plan-badge"
                            style={{
                                backgroundColor: planRow.tierMeta.bgColor,
                                color: planRow.tierMeta.textColor,
                                borderColor: planRow.tierMeta.borderColor,
                            }}
                        >
                            {planRow.tierMeta.badgeLabel}
                        </span>
                    </div>

                    <div className="selfcare360-plan-context-line">
                        Score: {formatVisibleNumber(planRow.score)} · Peso: {formatCompactPercent(planRow.weightPercent)} · Plazo: {planRow.actionWindow}
                    </div>

                    <div className="selfcare360-plan-sections-grid">
                        <section className="selfcare360-plan-section selfcare360-plan-section--supervisor">
                            <div className="selfcare360-plan-section-title">Para ti, {firstName}</div>
                            <ol className="selfcare360-plan-section-list">
                                {plan.supervisor.map((item) => <li key={item}>{item}</li>)}
                            </ol>
                        </section>

                        <section className="selfcare360-plan-section selfcare360-plan-section--manager">
                            <div className="selfcare360-plan-section-title">Para tu jefe directo</div>
                            <ol className="selfcare360-plan-section-list">
                                {plan.manager.map((item) => <li key={item}>{item}</li>)}
                            </ol>
                        </section>

                        <section className="selfcare360-plan-section selfcare360-plan-section--system">
                            <div className="selfcare360-plan-section-title">Para el sistema / área</div>
                            <ol className="selfcare360-plan-section-list">
                                {plan.system.map((item) => <li key={item}>{item}</li>)}
                            </ol>
                        </section>

                        <section className="selfcare360-plan-section selfcare360-plan-section--kpi">
                            <div className="selfcare360-plan-section-title">Indicadores de seguimiento</div>
                            <ul className="selfcare360-plan-kpi-list">
                                {plan.kpi.map((item) => <li key={item}>{item}</li>)}
                            </ul>
                        </section>
                    </div>
                </div>

                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageInterventionPlanDimensionSelfcare360;